<div class="py-10 flex flex-col justify-center sm:py-12">
    <div class="flex justify-center">
        <h2 class="font-light leading-relaxed text-3xl mt-0 mb-10 text-gray-800 cursor-default">Add Activity content for
            {{city}}</h2>
    </div>
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>
    <div class="mt-10 sm:mt-0 md:mx-20">
        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Innovative Action Category</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                            <!-- Innovative Action Category -->
                            <div class="grid grid-cols-2 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Select one from the list
                                    </label>
                                    <!-- Required form plugin -->
                                    <link
                                        href="https://cdn.jsdelivr.net/npm/@tailwindcss/custom-forms@0.2.1/dist/custom-forms.css"
                                        rel="stylesheet" />
                                    <select class="form-select block w-full mt-3" (ngModelChange)="onCategorySelect($event)"
                                        [(ngModel)]="actionCategory">
                                        <option disabled selected value="undefined"></option>
                                        <option *ngFor="let category of categories">
                                            {{category.Action_Cat}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-10 sm:mt-3 mx-20">
        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Action</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-3 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                            <!--Innovative Action -->
                            <div class="grid grid-cols-2 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Select one from the list
                                    </label>
                                    <!-- Required form plugin -->
                                    <link
                                        href="https://cdn.jsdelivr.net/npm/@tailwindcss/custom-forms@0.2.1/dist/custom-forms.css"
                                        rel="stylesheet" />
                                    <select class="form-select block w-full mt-3"
                                        [(ngModel)]="innovativeAction">
                                        <option disabled selected value="undefined"></option>
                                        <option *ngFor="let action of actions" value="{{action.Action}}">
                                            {{action.Action}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-10 sm:mt-3 mx-20">
        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Activity</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                            <!--Activity -->
                            <div class="grid grid-cols-2 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Select one from the list
                                    </label>
                                    <!-- Required form plugin -->
                                    <link
                                        href="https://cdn.jsdelivr.net/npm/@tailwindcss/custom-forms@0.2.1/dist/custom-forms.css"
                                        rel="stylesheet" />
                                    <select class="form-select block w-full mt-3" [(ngModel)]="activity">
                                        <option></option>
                                        <option class="text-sm" *ngFor="let activity of activities">{{activity.Activity}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-10 sm:mt-3 mx-20">
        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Other</h3>
                    <p class="text-justify text-sm mt-3 text-gray-500 italic">* Here you can write any other
                        activity not on the list above.
                    </p>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                            <!-- Other -->
                            <div>
                                <div class="mt-1 flex rounded-md shadow-sm">
                                    <input type="text" [(ngModel)]="other"
                                        *ngIf="activity == '' || activity == undefined"
                                        class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                        placeholder="Your Activity">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-10 sm:mt-3 mx-20">
        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Summary</h3>
                    <p class="text-justify text-sm mt-3 text-gray-500 italic">* Here you can write the summary of
                        your action.
                    </p>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                            <!-- Summary -->
                            <div>
                                <div class="mt-4">
                                    <quill-editor [modules]="QuillConfiguration" [(ngModel)]="summary"
                                        class=" shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                        placeholder="Your summary">
                                    </quill-editor>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Duration -->
            <div class="grid grid-cols-4 gap-6">
                <div class="col-span-3 sm:col-span-2">
                    <h3 class="text-lg font-medium text-gray-900">
                        Duration
                    </h3>
                    <p class="mt-1 text-sm text-red-300 italic">
                        *Starting date needs to be filled!
                    </p>
                    <div class="shadow overflow-hidden mt-3">
                        <div class="bg-white space-y-20 p-4">
                            <div class="flex rounded-md">
                                <input type="date" [(ngModel)]="durationFrom"
                                    class="h-8 border focus:ring-indigo-500 focus:border-indigo-500 mx-1 flex-1 block w-1/3 rounded-md sm:text-sm border-gray-300">
                                <input type="date" [(ngModel)]="durationTo"
                                    class="h-8 border focus:ring-indigo-500 focus:border-indigo-500 mx-1 flex-1 block w-1/3 rounded-md sm:text-sm border-gray-300">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-10 sm:mt-3 mx-20">
        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Learning Question</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                            <!--Learning Question -->
                            <div class="grid grid-cols-2 gap-6">
                                <div class="col-span-1 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Select one from the list
                                    </label>
                                    <!-- Required form plugin -->
                                    <link
                                        href="https://cdn.jsdelivr.net/npm/@tailwindcss/custom-forms@0.2.1/dist/custom-forms.css"
                                        rel="stylesheet" />
                                    <select class="form-select block w-full mt-3" [(ngModel)]="learningQuestion">
                                        <option> </option>
                                        <option *ngFor="let question of learningQuestions">{{question.LQ}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Submit -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>
    <div class="mt-10 sm:mt-0 text-center">
        <button (click)="onSubmit();" type="submit"
            class="inline-flex justify-center py-2 px-4 border border-transparent shadow-lg text-md font-medium rounded-md text-white bg-pink-800 disabled:bg-pink-400 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Submit Form
        </button>
    </div>

    <swal></swal>
</div>